import DOMPurify from "dompurify";

/**
 * Sanitizes an HTML string, allowing only safe tags produced by the Quill editor.
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "u", "s",
      "h2", "h3",
      "ul", "ol", "li",
      "blockquote", "pre",
      "a", "span",
    ],
    ALLOWED_ATTR: [
      "href", "target", "rel",
      "class", "style",
    ],
  });
}

/**
 * Strips all HTML tags from a string, returning plain text.
 */
export function stripHtml(html: string): string {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}
